const employeeOption = [
	{
		text: "Crab",
		value: "11",
		disabled: false,
	},
	{
		text: "Allen",
		value: "12",
		disabled: false,
	},
	{
		text: "Sabrina",
		value: "14",
		disabled: false,
	},
	{
		text: "凱西",
		value: "18",
		disabled: false,
	},
];

export { employeeOption };
